module.exports = {
	following: "Seguindo",
	followers: "Seguidores",
	friends: "Amigos",
	currentLevel: "Nível atual",
	nextLevel:
		"Fique entre os 4 primeiros do ranking semanal para avançar para o próximo nível",
}